let xVal = 0;
let yVal = 0;

const defaultObj = {};

export const disableScroll = (
  element,
  { stopScrollClass = "stop-scroll", addTopMargin = true } = defaultObj,
) => {
  xVal = window.scrollX || window.pageXOffset;
  yVal = window.scrollY || window.pageYOffset;

  element.classList.add(stopScrollClass);
  // added css as body position is fixed and we don't want to scroll to top
  if (addTopMargin) {
    element.style.marginTop = `-${yVal}px`;
  }
  element.style.marginLeft = `-${xVal}px`;
};

export const enableScroll = (
  element,
  stopScrollClass = "stop-scroll",
  scrollBackToPrevCoord = true,
) => {
  // resetting added styling

  element.classList.remove(stopScrollClass);
  element.style.marginTop = "";
  element.style.marginLeft = "";
  scrollBackToPrevCoord && window.scrollTo(xVal, yVal);
  (xVal = 0), (yVal = 0);
};

export const getScrollCoordinates = (el, parentEl) => {
  const parentElRect = parentEl?.getBoundingClientRect?.();
  const rect = el.getBoundingClientRect();
  const scrollLeft =
    parentEl?.scrollLeft ?? (window.pageXOffset || document.documentElement.scrollLeft);
  const scrollTop =
    parentEl?.scrollTop ?? (window.pageYOffset || document.documentElement.scrollTop);
  return {
    top: rect?.top - (parentElRect?.top || 0) + scrollTop,
    left: rect?.left - (parentElRect?.left || 0) + scrollLeft,
  };
};

export const scrollInContainer = ({
  container = window,
  scrollDistance = 0,
  behavior = "smooth",
}) => {
  if (container) {
    container.scrollTo?.({
      top: scrollDistance,
      left: scrollDistance,
      behavior,
    });
  }
};

export const scrollToContainerWithRef = ({
  parentContainerRef,
  ref,
  topOffset = 0,
  behavior,
  direction = "top",
}) => {
  const currentContainer = ref?.current;
  const parentContainer = parentContainerRef?.current || window;
  if (currentContainer) {
    const { top, left } = getScrollCoordinates(currentContainer, parentContainer);
    const scrollDistance = (direction === "top" ? top : left) - topOffset;

    scrollInContainer({
      container: parentContainer,
      scrollDistance,
      behavior,
    });
  }
};
